(() => {
  if (window.plainJaneCollectionFiltersInstalled) return;
  window.plainJaneCollectionFiltersInstalled = true;

  const pendingUpdates = new WeakMap();
  let scrollIntent = 0;
  const recordScrollIntent = () => { scrollIntent += 1; };
  window.addEventListener('wheel', recordScrollIntent, { passive: true });
  window.addEventListener('touchmove', recordScrollIntent, { passive: true });
  window.addEventListener('keydown', (event) => {
    if (['PageUp', 'PageDown', 'Home', 'End', 'ArrowUp', 'ArrowDown', ' '].includes(event.key)) {
      recordScrollIntent();
    }
  });

  // Enter in a price field must follow the same path as a checkbox change.
  // Retain normal form behavior if the theme's filter component fails to load.
  document.addEventListener('keydown', (event) => {
    const input = event.target;
    if (event.key !== 'Enter' || event.isComposing || !(input instanceof HTMLInputElement)) return;
    const form = input.closest('form[is="filter-form"]');
    if (!input.name.startsWith('filter.v.price.') || typeof form?.buildUrl !== 'function') return;
    event.preventDefault();
    form.requestSubmit();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[is="filter-form"]')) return;
    if (typeof form.buildUrl !== 'function' || !form.closest('collection-section')) return;
    event.preventDefault();
    form.dispatchEvent(new CustomEvent('collection:filter-change', {
      bubbles: true,
      detail: { url: form.buildUrl().toString() },
    }));
  });

  // The editorial sidebar stays in place while results update. Reuse the
  // theme's request cancellation, DOM reconciliation, URL and focus handling.
  document.addEventListener('collection:filter-change', async (event) => {
    const section = event.target instanceof Element
      ? event.target.closest('collection-section.pj-arete-collection__section')
      : null;
    if (!section || typeof section.update !== 'function' || !event.detail?.url) return;
    event.stopPropagation();
    const update = { left: window.scrollX, top: window.scrollY, scrollIntent };
    pendingUpdates.set(section, update);
    await section.update(event.detail.url);
    // Adding/removing active-filter chips can trigger browser scroll anchoring.
    // Only restore for the latest request, and never undo deliberate scrolling.
    if (pendingUpdates.get(section) === update && scrollIntent === update.scrollIntent) {
      window.scrollTo({ left: update.left, top: update.top, behavior: 'instant' });
    }
  }, true);
})();
